import { ApiUserRole } from '@/enum/ApiUserRole'
import { TemplateMail } from '@/enum/TemplateMail'
import { AloAddress, getDefaultAloAddress } from './AloAddress'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloNewCarte extends AloBase {                
    qty: number  
    validiteM:  number  
}

export const getDefaultAloNewCarte = ():AloNewCarte => {
    return {  
        ...getDefaultAloBase(),        
        qty : 1,
        validiteM : 1  
    }
}


export const cleanAloNewCarte = (carte:AloNewCarte) => {
    if(!carte) return    
    if(!carte.id) delete carte.id 
}

